<template>
  <div class="vessel-types-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            @click.prevent="exportCsv()"
            class="btn-color ml-4"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.vessel_type") }}</label>
          <v-select
            v-model="vessel_type"
            :options="filter_vessel_types"
            :reduce="(filter_vessel_types) => filter_vessel_types.id"
            label="name"
            name="types"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search && !this.vessel_type"
            class="w-full sm:ml-0 md:ml-4 px-3 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.vessel_type"
            class="sm:ml-0 md:ml-4 px-12 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.vessel_types')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.vessel_types") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddVesselType' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('vessel-types', 'add')"
              >{{ $t("labels.add_vessel_type") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="vesselTypes" class="permission">
        <template slot="thead">
          <vs-th class="col-md-2">{{ $t("labels.number") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.parent_vessel_type") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.vessel_number }}</vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>{{ tr.parent ? tr.parent.name : "-" }}</vs-td>
            <vs-td width="125">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  v-if="checkPermission('vessel-types', 'modify')"
                  @click="
                    $router.push({
                      name: 'EditVesselType',
                      params: { id: tr.id },
                    })
                  "
                ></vs-button>
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-if="checkPermission('vessel-types', 'delete')"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vessel_type: 0,
      filter_vessel_types: [],
      vesselTypes: [],
      index: -1,
      totalPage: 1,
      currentx: 1,
      // limit: this.$store.state.limit,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
    };
  },
  watch: {
    showfilter(val) {
      if (val == true) {
        this.getfilterVesselTypes();
      }
    },
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getVesselTypes();
    },
    currentx(val) {
      this.getVesselTypes();
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getVesselTypes();
    // this.getfilterVesselTypes();
  },
  methods: {
    openFilter() {
      this.getfilterVesselTypes();
    },
    deleteConfirm(index) {
      this.index = index;
      let text = this.$t("strings.delete_confirm");
      if (!this.vesselTypes[index].parent) {
        text = this.$t("strings.delete_confirm_with_subtype");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.deleteVesselType,
      });
    },
    async deleteVesselType() {
      if (this.index < 0) return;
      let url = "vesselType/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.vesselTypes[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getVesselTypes();
      }
    },
    async getVesselTypes(exp = false) {
      let input = {
        only_parents: true,
        with_children: true,
        page: this.currentx,
        perPage: this.limit,
      };
      if (this.search) {
        let input1 = {
          search: this.search,
        };
        Object.assign(input, input1);
      }
      if (this.vessel_type) {
        let input2 = {
          parent_id: this.vessel_type,
        };
        Object.assign(input, input2);
      }
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/vesselType/list", input);
      if (exp) {
        this.exportFile(response, "VesselTypes");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          this.vesselTypes = [];
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          data.vesselTypes.map((parent) => {
            this.vesselTypes.push(parent);
            if (parent.children) {
              parent.children.map((child) => {
                child.parent = parent;
                this.vesselTypes.push(child);
              });
            }
          });
        }
      }
    },
    // new function added for filter to be work
    async getSearchVesselTypes(exp = false) {
      let input = {
        only_parents: false,
        with_children: false,
        page: this.currentx,
        perPage: this.limit,
      };
      if (this.search) {
        let input1 = {
          search: this.search,
        };
        Object.assign(input, input1);
      }
      if (this.vessel_type) {
        let input2 = {
          parent_id: this.vessel_type,
        };
        Object.assign(input, input2);
      }
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/vesselType/list", input);
      if (exp) {
        this.exportFile(response, "VesselTypes");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          this.vesselTypes = [];
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          data.vesselTypes.map((parent) => {
            this.vesselTypes.push(parent);
            if (parent.children) {
              parent.children.map((child) => {
                child.parent = parent;
                this.vesselTypes.push(child);
              });
            }
          });
        }
      }
    },
    async getfilterVesselTypes() {
      let input = {
        only_parents: true,
        with_children: false,
      };
      let response = await this.getHTTPPostResponse("/vesselType/list", input);
      if (response) {
        let data = response.data;
        this.filter_vessel_types = data.vesselTypes;
      }
    },
    exportCsv() {
      this.getVesselTypes(true);
    },
    filter() {
      this.getSearchVesselTypes();
    },
    clearFilter() {
      this.search = null;
      this.vessel_type = null;
      this.getVesselTypes();
    },
  },
};
</script>
